import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { LinkContainer } from "react-router-bootstrap";
import { useAuth } from "./../util/auth.js";
import {useRouter} from 'util/router'
import "./Pricing.scss";

function Pricing(props) {
  const auth = useAuth();

  const router = useRouter()

  return (
    <Row className="justify-content-center">
      {props.items.map((item, index) => (
        <Col
          md={12}
          lg={4}
          className="py-3 d-flex align-items-stretch"
          key={index}
        >
          <Card className={`w-100` + (item.selected ? " Pricing__selected" : "")}>
            <Card.Body className="d-flex flex-column p-4">
              <h5 className="font-weight-bold mb-4">{item.name}</h5>
              <h1 className="font-weight-bold mb-3">
                {/* ${item.price} */}
                ${item.price}
                <small className="Pricing__period">/mo</small>
              </h1>
              <small>{item.bookingFee}</small>

              {item.description && (
                <Card.Text className="mb-4">{item.description}</Card.Text>
              )}
              {item.perks && (
                <div className="mt-2">
                  <ul className="list-unstyled">
                    {item.perks.map((perk, index) => (
                      <li className="py-1" key={index}>
                        <i className="fas fa-angle-right mr-3"></i>
                        {perk}
                      </li>
                    ))}
                  </ul>
                  {item.description}
                </div>
              )}

              {/* Monthly */}
              <div className="mt-auto">
                <LinkContainer
                  to={
                    auth.user
                      ? `/purchase/${item.id}`
                      : `/auth/signup?next=/purchase/${item.id}` + (router.query.secret ? `&secret=${router.query.secret}` : "")
                  }
                >
                  <Button
                    variant="outline-primary"
                    size="lg"
                    block={true}
                    className="mt-auto mb-2"
                    disabled={item.monthlySelected}
                  >
                    {item.monthlySelected ? "Subscribed" : "Choose monthly"}
                  </Button>
                </LinkContainer>

                {item.annualId && (
                  <LinkContainer
                    to={
                      auth.user
                        ? `/purchase/${item.annualId}`
                        : `/auth/signup?next=/purchase/${item.annualId}` + (router.query.secret ? `&secret=${router.query.secret}` : "")
                    }
                  >
                    <Button
                      variant="primary"
                      size="lg"
                      block={true}
                      className="mt-auto"
                      disabled={item.annualSelected}
                    >
                      {item.annualSelected ? "Subscribed" : "Annual (save 17%)"}
                      {/* <small>&nbsp;{item.annualSelected ? "" : `$${item.annualPrice}/mo`}</small> */}
                      {/* <small>&nbsp;save 17%</small> */}
                    </Button>
                  </LinkContainer>
                )}

              </div>

            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default Pricing;
